import { IPartsManagerState } from './parts-manager.state';
import { createReducer, on } from '@ngrx/store';
import {
  createDamageSeverity,
  createDamageSeverityFailure,
  createDamageSeveritySuccess,
  createDamageType,
  createDamageTypeFailure,
  createDamageTypeSuccess,
  createPart,
  createPartFailure,
  createPartSuccess,
  deletePart,
  deletePartFailure,
  deletePartsBulk,
  deletePartsBulkFailure,
  deletePartsBulkSuccess,
  deletePartSuccess,
  deleteSeveritiesBulk,
  deleteSeveritiesBulkFailure,
  deleteSeveritiesBulkSuccess,
  deleteSeverity,
  deleteSeverityFailure,
  deleteSeveritySuccess,
  deleteType,
  deleteTypeFailure,
  deleteTypesBulk,
  deleteTypesBulkFailure,
  deleteTypesBulkSuccess,
  deleteTypeSuccess,
  loadAreas,
  loadAreasFailure,
  loadAreasSuccess,
  loadParts,
  loadPartsFailure,
  loadPartsSuccess,
  loadSeverities,
  loadSeveritiesFailure,
  loadSeveritiesSuccess,
  loadTypes,
  loadTypesFailure,
  loadTypesSuccess,
  resetLastCreatedDamageSeverity,
  resetLastCreatedDamageType,
  resetLastCreatedPart,
  updatePart,
  updatePartFailure,
  updatePartSuccess,
} from './parts-manager.actions';

export const initialState: IPartsManagerState = {
  parts: [],
  types: [],
  severities: [],
  areas: [],
  lastCreatedPart: undefined,
  lastCreatedDamageType: undefined,
  lastCreatedDamageSeverity: undefined,
  loading: false,
  error: null,
};
export const partsManagerReducer = createReducer(
  initialState,
  on(loadParts, (state) => {
    return {
      ...state,
      loading: true,
    };
  }),
  on(loadPartsSuccess, (state, { parts }) => {
    return {
      ...state,
      parts: parts.filter((part) => !!part.isActive),
      loading: false,
    };
  }),
  on(loadPartsFailure, (state) => {
    return {
      ...state,
      loading: false,
    };
  }),
  on(loadTypes, (state) => {
    return {
      ...state,
      loading: true,
    };
  }),
  on(loadTypesSuccess, (state, { types }) => {
    return {
      ...state,
      types: types.filter((type) => !!type.isActive),
      loading: false,
    };
  }),
  on(loadTypesFailure, (state) => {
    return {
      ...state,
      loading: false,
    };
  }),
  on(loadSeverities, (state) => {
    return {
      ...state,
      loading: true,
    };
  }),
  on(loadSeveritiesSuccess, (state, { severities }) => {
    return {
      ...state,
      severities: severities.filter((item) => !!item.isActive),
      loading: false,
    };
  }),
  on(loadSeveritiesFailure, (state) => {
    return {
      ...state,
      loading: false,
    };
  }),
  on(loadAreas, (state) => {
    return {
      ...state,
      loading: true,
    };
  }),
  on(loadAreasSuccess, (state, { areas }) => {
    return {
      ...state,
      areas,
      loading: false,
    };
  }),
  on(loadAreasFailure, (state) => {
    return {
      ...state,
      loading: false,
    };
  }),
  on(createPart, (state) => {
    return {
      ...state,
      createLoading: true,
    };
  }),
  on(createPartSuccess, (state, { part }) => {
    return {
      ...state,
      parts: [part, ...state.parts],
      lastCreatedPart: part,
      createLoading: false,
    };
  }),
  on(createPartFailure, (state) => {
    return {
      ...state,
      createLoading: false,
    };
  }),
  on(resetLastCreatedPart, (state) => {
    return {
      ...state,
      lastCreatedPart: undefined,
    };
  }),
  on(updatePart, (state) => {
    return {
      ...state,
      createLoading: true,
    };
  }),
  on(updatePartSuccess, (state, updatedPart) => ({
    ...state,
    parts: state.parts.map((part) =>
      part.id === updatedPart.id ? { ...part, ...updatedPart } : part
    ),
    createLoading: false,
  })),
  on(updatePartFailure, (state) => {
    return {
      ...state,
      createLoading: false,
    };
  }),
  on(createDamageType, (state) => {
    return {
      ...state,
      createLoading: true,
    };
  }),
  on(createDamageTypeSuccess, (state, { damageType }) => {
    return {
      ...state,
      types: [damageType, ...state.types],
      lastCreatedDamageType: damageType,
      createLoading: false,
    };
  }),
  on(createDamageTypeFailure, (state) => {
    return {
      ...state,
      createLoading: false,
    };
  }),
  on(resetLastCreatedDamageType, (state) => {
    return {
      ...state,
      lastCreatedDamageType: undefined,
    };
  }),
  on(createDamageSeverity, (state) => {
    return {
      ...state,
      createLoading: true,
    };
  }),
  on(createDamageSeveritySuccess, (state, { severity }) => {
    return {
      ...state,
      severities: [severity, ...state.severities],
      lastCreatedDamageSeverity: severity,
      createLoading: false,
    };
  }),
  on(createDamageSeverityFailure, (state) => {
    return {
      ...state,
      createLoading: false,
    };
  }),
  on(resetLastCreatedDamageSeverity, (state) => {
    return {
      ...state,
      lastCreatedDamageSeverity: undefined,
    };
  }),
  on(deletePart, (state) => {
    return {
      ...state,
      loading: true,
    };
  }),
  on(deletePartSuccess, (state, { id }) => {
    return {
      ...state,
      parts: state.parts.filter((part) => part.id !== id),
      loading: false,
    };
  }),
  on(deletePartFailure, (state) => {
    return {
      ...state,
      loading: false,
    };
  }),
  on(deleteType, (state) => {
    return {
      ...state,
      loading: true,
    };
  }),
  on(deleteTypeSuccess, (state, { id }) => {
    return {
      ...state,
      types: state.types.filter((type) => type.id !== id),
      loading: false,
    };
  }),
  on(deleteTypeFailure, (state) => {
    return {
      ...state,
      loading: false,
    };
  }),
  on(deleteSeverity, (state) => {
    return {
      ...state,
      loading: true,
    };
  }),
  on(deleteSeveritySuccess, (state, { id }) => {
    return {
      ...state,
      severities: state.severities.filter((severity) => severity.id !== id),
      loading: false,
    };
  }),
  on(deleteSeverityFailure, (state) => {
    return {
      ...state,
      loading: false,
    };
  }),
  on(deletePartsBulk, (state) => {
    return {
      ...state,
      loading: true,
    };
  }),
  on(deletePartsBulkSuccess, (state, { parts }) => {
    return {
      ...state,
      parts: state.parts.filter(
        (part) => !parts?.some((item) => item.id === part.id)
      ),
      loading: false,
    };
  }),
  on(deletePartsBulkFailure, (state) => {
    return {
      ...state,
      loading: false,
    };
  }),
  on(deleteTypesBulk, (state) => {
    return {
      ...state,
      loading: true,
    };
  }),
  on(deleteTypesBulkSuccess, (state, { types }) => {
    return {
      ...state,
      types: state.types.filter(
        (type) => !types?.some((item) => item.id === type.id)
      ),
      loading: false,
    };
  }),
  on(deleteTypesBulkFailure, (state) => {
    return {
      ...state,
      loading: false,
    };
  }),
  on(deleteSeveritiesBulk, (state) => {
    return {
      ...state,
      loading: true,
    };
  }),
  on(deleteSeveritiesBulkSuccess, (state, { severities }) => {
    return {
      ...state,
      severities: state.severities.filter(
        (part) => !severities?.some((item) => item.id === part.id)
      ),
      loading: false,
    };
  }),
  on(deleteSeveritiesBulkFailure, (state) => {
    return {
      ...state,
      loading: false,
    };
  })
);
